import React, { useEffect, useState, useRef, useCallback } from 'react';

export default function useForm({ protect } = {}) {
  const [formErrorLength, setFormErrorLength] = useState(0);
  const [validated, setValidated] = useState(false);

  const formRef = useRef();

  useEffect(() => {
    const timeoutNum = setTimeout(() => {
      //below will not be accurate until post-render, will check after a render buffer of 20ms
      setFormErrorLength(formRef.current?.querySelectorAll(':invalid').length);
    }, 20);

    return () => {
      clearTimeout(timeoutNum);
    };
  });

  const setFormRef = (ref) => {
    if (ref) {
      ref.addEventListener('change', handleChange);
      ref.addEventListener('submit', (event) => event.preventDefault());
      formRef.current = ref;
    }
  };

  const handleChange = () => {
    if (protect) {
      //disabling for now, soluton has some bugs
      //window.onbeforeunload = () => true;
    }
  };

  const handleSubmit = () => {
    if (protect) {
      window.onbeforeunload = null;
    }
    if (formRef.current) {
      formRef.current.removeEventListener('change', handleChange);
    }
  };

  const handleCancelSubmit = () => {
    handleChange();
    if (formRef.current) {
      formRef.current.addEventListener('change', handleChange);
    }
  };

  const isFormValid = () => {
    if (formRef.current) {
      formRef.current.classList.add('was-validated');
      setValidated(true);
      return formRef.current.checkValidity();
    }
    return true; //is this the correct default?
  };

  const submitForm = useCallback((onValid, onInvalid) => async () => {
    if (isFormValid()) {
      if (onValid) {
        handleSubmit();
        await onValid(handleCancelSubmit); //use handleChange as the cancel callback to reset protection
      }
    }
    else {
      if (onInvalid) {
        await onInvalid();
      }
    }
  }, []);

  const resetForm = () => {
    if (formRef.current) {
      formRef.current.classList.remove('was-validated');
      setValidated(false);
    }
  };

  const hasFormValidationError = () => {
    return validated && formErrorLength > 0;
  };

  const getFormValidationMessage = () => {
    if (hasFormValidationError()) {
      if (formErrorLength === 1) {
        return 'There is 1 problem, please correct it above';
      }
      else {
        return `There are ${formErrorLength} problems, please correct them above`;
      }
    }
    return null;
  };

  const renderFormValidationMessage = () => {
    if (hasFormValidationError()) {
      return (
        <div className='text-danger mx-1 mb-2'>
          <h5 className='d-inline mr-2'><i className='icons8-delete-shield' /> Warning</h5>
          <span>{getFormValidationMessage()}</span>
        </div>
      );
    }
    return null;
  };

  return { setFormRef, isFormValid, submitForm, resetForm, formErrorLength, hasFormValidationError, getFormValidationMessage, renderFormValidationMessage };
}